export default "__VITE_ASSET__DuZjDgab__"